angular.module("screensApp")

  .controller("ToastNotifications", function ($scope, $rootScope, $filter, $timeout) {
      
    // Helper function to find a toast notification by ID
    function findToastById(id) {
      var filteredToasts = $filter('filter')($rootScope.toastNotifications, { 'id': id });
      return filteredToasts.length > 0 ? filteredToasts[0] : null;
    }

    // Hide Toast Notification
    $rootScope.hideToastNotification = function (data) {
      var toast = findToastById(data.id);
      if (toast) {
        toast.cssclass += ' hiding';
        $timeout.cancel(toast.timeoutRef);
        toast.timeoutRef = false;
        $timeout(function() {
          toast.visible = false;
          $rootScope.removeToastNotification(data);
        }, 300);
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideToastNotification()');
        !$rootScope.$$phase && $rootScope.$apply();
      }
    };

    // Show Toast Notification
    $rootScope.showToastNotification = function (data) {
      var toast = findToastById(data.id);

      var timeoutDuration = data.timeout * 1000 || 5000; // Default to 5 seconds if no timeout is provided

      if (toast) {
        // Update existing toast
        if (data.text) {
          toast.text = data.text;
        }
        if (data.icon) {
          toast.icon = data.icon;
        }
        toast.visible = true;
      } else {
        // Add new toast notification
        toast = {
          id: data.id,
          text: data.text || '',
          icon: data.icon || '',
          cssclass: data.cssclass || '',
          timeoutRef: false,
          visible: true
        };
        // Set timeout to hide the toast notification after the specified duration
        toast.timeoutRef = $timeout(function() {
          $rootScope.hideToastNotification(data);
        }, timeoutDuration);
        
        $rootScope.toastNotifications.push(toast);
      }

      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showToastNotification() data: ' + JSON.stringify(data));
      !$rootScope.$$phase && $rootScope.$apply();
    };

    // Remove Toast Notification
    $rootScope.removeToastNotification = function (data) {
      var toast = findToastById(data.id);
      if (toast) {
        var index = $rootScope.toastNotifications.indexOf(toast);
        if (index !== -1) {
          $rootScope.toastNotifications.splice(index, 1);
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: removeToastNotification() data: ' + JSON.stringify(data));
          !$rootScope.$$phase && $rootScope.$apply();
        }
      }
    };
  });
